<template>
  <form enctype="multipart/form-data" novalidate>
    <div class="dropbox bg-bg"
         @drop.prevent="drop"
         @dragover.prevent="dragover"
         @dragleave.prevent="dragleave">
      <input type="file" id="file" ref="file" name="file"
             @change.prevent="handleFileUpload"
             :accept="accept">
      <div class="flex items-center text-md relative z-60" @click="start">
        <slot>
          <IconFileUpload class="text-border-hover mr-8"/>
          <p>Загрузить свое изображение</p>
        </slot>
      </div>
    </div>
  </form>
</template>

<script>
import IconFileUpload from "@/components/icons/FileIcons/IconFileUpload";

export default {
  name: "DropBoxFileUpload",
  components: {IconFileUpload},
  props: {
    accept: {
      type: Array,
    },
    multiple: {
      type: Boolean
    }
  },
  methods: {
    start() {
      this.$refs.file.click()
    },
    dragover(event) {
      // Emulate hover style
      if (event.currentTarget.classList.contains('bg-bg')) {
        event.currentTarget.classList.remove('bg-bg');
        event.currentTarget.classList.add('bg-block-secondary');
      }
    },
    dragleave(event) {
      // Clean up hover style
      event.currentTarget.classList.add('bg-bg');
      event.currentTarget.classList.remove('bg-block-secondary');
    },
    drop(event) {
      this.$refs.file.files = event.dataTransfer.files;
      this.handleFileUpload()
    },
    handleFileUpload() {
      if (this.multiple) {
        this.$emit('input', this.$refs.file.files)
      } else {
        this.$emit('input', this.$refs.file.files[0])
      }
    },
  }
}
</script>

<style lang="scss">
.dropbox {
  @apply text-text-label transition duration-200 p-4 relative cursor-pointer
  flex items-center justify-center;
  outline: 2px dashed var(--border-hover);
  outline-offset: -5px;
  min-height: 70px;

  &:hover {
    @apply bg-block-secondary;
  }

  input {
    @apply opacity-0 w-full h-full absolute cursor-pointer z-60;
  }
}
</style>